
// UI 
import ForecolorIcon from "../../UI/Forecolor/ForecolorIcon";
import Forecolor from "../../UI/Forecolor/Forecolor.svelte";

// Utils
import { __colors__ } from "../../constants"
// Types
import type { ActiveEditor } from "../../types"
// Constatns
const tooltip = `font-color`;
// Export default
export default function forecolorSetup(editor: ActiveEditor, colors = __colors__, defaultColor = "#46474B") {


    const pickerValue = "picker"
    const addedColorNames = addColorIcons(editor, colors)
    const DEFAULT_TEXT_COLOR_ICON = "DEFAULT_TEXT_COLOR_ICON"
    // 
    let currentColor = defaultColor
    //  
    editor.ui.registry.addIcon(DEFAULT_TEXT_COLOR_ICON, ForecolorIcon);
    editor.ui.registry.addSplitButton('color', {
        icon: DEFAULT_TEXT_COLOR_ICON,
        tooltip: tooltip,
        columns: 5,
        onAction: function () {
            editor.execCommand('ForeColor', false, currentColor);
        },
        onSetup: function (_) {
            setIconColor(currentColor)
        },
        onItemAction: function (api, value) {
            if (value === pickerValue) {
                const editArea = getEditorArea()
                const foreColorComponent = new Forecolor({
                    target: editArea
                })
                editor.getBody().setAttribute('contenteditable', "false");
                foreColorComponent.$on("SAVE", (e: { detail: string }) => {
                    const { detail } = e;
                    editor.getBody().setAttribute('contenteditable', "true");
                    editor.execCommand('ForeColor', false, detail);
                    currentColor = detail
                    setIconColor(currentColor)
                    foreColorComponent.$destroy()
                })
                foreColorComponent.$on("CANCEL", () => {
                    editor.getBody().setAttribute('contenteditable', "true");
                    foreColorComponent.$destroy()
                })
            } else {
                currentColor = value
                setIconColor(currentColor)
                editor.execCommand('ForeColor', false, value);
            }
        },
        fetch: function (callback) {
            const items = addedColorNames.map((v) => {
                return {
                    type: 'choiceitem',
                    icon: `${v.name}`,
                    value: v.hax,
                }
            })

            const picker = {
                type: "choiceitem",
                icon: "color-picker",
                value: pickerValue
            }

            callback([...items, picker]);
        }
    });
}

function addColorIcons(editor: ActiveEditor, colors: string[]) {
    const colorNames = [];
    for (let i = 0; i < colors.length; i += 2) {
        editor.ui.registry.addIcon(colors[i + 1], `<div style="width:24px;height:24px;background : ${colors[i]}" />`);
        colorNames.push({
            hax: colors[i],
            name: colors[i + 1]
        })
    }

    return colorNames

}


function getEditorArea() {
    return document.querySelector("div.tox-edit-area") as HTMLElement;
}

function setIconColor(color: string) {
    const button = document.querySelector(`div[title=${tooltip}]`) as HTMLDivElement
    const COLOR_ID = "tox-icon-text-color__color"
    const colorEL = button.querySelector("#" + COLOR_ID) as SVGPathElement;

    colorEL.style.fill = color;
}